import React, { useEffect, useState } from "react";
import NKJYardExMonthWise from "./NKJYardExMonthWise";
import axios from "axios";
import { flattenData, getCurrentFY, getLastFYyears } from "../../../Utilitie";
import NKJYardFyearWise from "./NKJYardFyearWise";
import NKJYardMWData from "./NKJYardMWData";
import NKJController from "./NKJController";
import DispatchAndTerminalDetentionMaster from "./Dispatch and Terminal Detention/DispatchAndTerminalDetentionMaster";
import NKJFlowMaster from "./TrafficFlow/NKJFlowMaster";
const opState = {
  Year: false,
  Month: false,
};
const pages = [
  "Examination",
  "Sick , Dispatch and Terminal Detention",
  "Traffic Flow",
];
const NKJYardExMaster = () => {
  const [activePage, stActivePage] = useState("Examination");
  const fys = getLastFYyears();
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [fyYears, setFyYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [selectedFy, setSelectedFy] = useState(
    getCurrentFY().replace("_", "-"),
  );
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}nkjboxndetention?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setFyYears(response.previousFinancialYears);
          setRawData(response.data);
          let temp = flattenData(response.data);
          setData(temp);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  return (
    <div className="">
      <div class="row sticky-controller newUiBodyNM">
        <div className="col-md-4 d-flex align-items-center newUiBodyNM">
          <select
            className="form-select text-black fw-bolder text-center form-control  papaDiv"
            onChange={(e) => {
              setSelectedFy(e.target.value);
            }}
          >
            <option value="" hidden>
              Select Financial Year
            </option>

            {fys.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-8  newUiBodyNM">
          <NKJController
            data={data}
            setSelectedFilters={setSelectedFilters}
            setFilteredData={setFilteredData}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
        </div>
      </div>{" "}
      <div className="row m-2 newUiBodyNM">
        <div className="d-flex justify-content-center">
          {pages.map((page, i) => (
            <button
              key={i}
              onClick={() => stActivePage(page)}
              className={`btn btn-outline-dark m-2 Subject ${
                activePage === page && "active"
              }`}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
      {activePage === "Examination" && (
        <div className="fade-in-up">
          {filteredData && (
            <div className="newUiBodyNM ">
              <NKJYardFyearWise data={filteredData} />
            </div>
          )}
          {rawData && (
            <div className="papaDiv ">
              <NKJYardExMonthWise data={rawData} selectedFy={selectedFy} />
            </div>
          )}
          {filteredData && (
            <div className="papaDiv ">
              <NKJYardMWData data={filteredData} />
            </div>
          )}
        </div>
      )}
      {activePage === "Sick , Dispatch and Terminal Detention" && (
        <div className="fade-in-up">
          <DispatchAndTerminalDetentionMaster
            data={filteredData}
            selectedFy={selectedFy}
            selectedFilters={selectedFilters}
          />
        </div>
      )}
      {activePage === "Traffic Flow" && (
        <div className="fade-in-up">
          <NKJFlowMaster
            selectedFy={selectedFy}
            selectedFilters={selectedFilters}
          />{" "}
        </div>
      )}
    </div>
  );
};
export default NKJYardExMaster;
